import React from 'react';
import SectionNavigationButton from './SectionNavigationButton';

export default React.memo(SectionNavigationButton);
